export default __webpack_public_path__ + "static/media/instagram.c76e6ec6.svg";